import Home from '../views/Home.vue';
import PerDayTankStatusReport from '../views/PerDayTankStatusReport.vue';
import PerDayVoyageReport from '../views/PerDayVoyageReport.vue';
import VesselOverview from '../views/VesselOverview.vue';
import Tanks from '../views/Tanks.vue';
import TankDetails from '../views/TankDetails.vue';
import VoyageReports from '../views/VoyageReports.vue';
import VoyageDetails from '../views/VoyageDetails.vue';
import UserAdmin from '../views/UserAdmin.vue';
import DataAdmin from '../views/DataAdmin.vue';
import Account from '../views/Account.vue';
import Unauthorized from '../views/Unauthorized.vue';
import NotFound from '../views/NotFound.vue';

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
    display: 'Home',
    icon: 'home',
  },
  {
    name: 'useradmin',
    path: '/useradmin',
    component: UserAdmin,
    display: 'Data',
    icon: 'list',
    meta: { restrictToRoles: ['Admin'] },
  },
  {
    name: 'dataadmin',
    path: '/dataadmin',
    component: DataAdmin,
    display: 'Data',
    icon: 'list',
    meta: { restrictToRoles: ['Admin', 'DataAdmin'] },
  },
  {
    name: 'account',
    path: '/account',
    component: Account,
    display: 'Account',
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'vesseloverview',
    path: '/vessel-overview',
    component: VesselOverview,
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'tanks',
    path: '/tanks',
    component: Tanks,
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'tankDetails',
    path: '/tank-details/:id',
    component: TankDetails,
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'perDayTankStatus',
    path: '/perday-tank-status',
    component: PerDayTankStatusReport,
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'perDayVoyageReport',
    path: '/perday-voyage-report/:date?',
    component: PerDayVoyageReport,
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'voyagereports',
    path: '/voyage-reports',
    component: VoyageReports,
    icon: 'list',
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'voyagedetails',
    path: '/voyage-details/:id?/:idc?',
    component: VoyageDetails,
    meta: { restrictToRoles: ['User'] },
  },
  {
    name: 'unauthorized',
    path: '/unauthorized',
    component: Unauthorized,
  },
  {
    name: 'notfound',
    path: '*',
    component: NotFound,
  },
];

export default routes;
